import {HelpPages} from "modules/enums";
import {createAction} from "redux-act";

export const fetchHelpPage = createAction<HelpPages>();

interface IHelpPage {
	id: number;
	type: string;
	title: string;
	text: string;
}

export const fetchHelpPageSuccess = createAction<Partial<Record<HelpPages, IHelpPage>>>();
